import { render, staticRenderFns } from "./AuditUserLinkList.vue?vue&type=template&id=237da118&scoped=true"
import script from "./AuditUserLinkList.vue?vue&type=script&lang=js"
export * from "./AuditUserLinkList.vue?vue&type=script&lang=js"
import style0 from "./AuditUserLinkList.vue?vue&type=style&index=0&id=237da118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237da118",
  null
  
)

export default component.exports